import PropTypes from 'prop-types';
import React from 'react';

import './ProfileUserDetailHeader.scss';

export default class ProfileUserDetailHeader extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        name: PropTypes.string.isRequired,
        website: PropTypes.string,
        jobTitle: PropTypes.string,
        location: PropTypes.string,
    };

    static defaultProps = {};

    render() {
        const { name, jobTitle, location, website } = this.props;

        return (
            <div className="component-Employer-VCFPortal-ProfileUserDetailHeader">
                <div className="user-full-name">{name}</div>
                {website && (
                    <a className="user-website" href={website}>
                        {website}
                    </a>
                )}
                {jobTitle && (
                    <div className="user-current-position">{jobTitle}</div>
                )}
                {location && <div className="user-location">{location}</div>}
            </div>
        );
    }
}
